import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { MsalUser } from "@schema/auth/msal-user";
import { ApiService } from "./api.service";
import { IUser, User, IUserImport } from "@schema/user";
import { IHttpResponse, IHttpErrorResponse } from "@schema/http";
import { environment } from "@env";
import { BehaviorSubject } from "rxjs";
import { ContextService } from "./context.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class AuthService {

  /**
   * The current user's profile
   */
  public user$: BehaviorSubject<IUser> = new BehaviorSubject(new User({}));

  protected _hasLoaded = false;

  constructor(
    protected readonly _msalService: MsalService,
    protected readonly _apiService: ApiService,
    protected readonly _contextService: ContextService,
    protected readonly _router: Router,
  ) { }

  /**
   * Auth login
   */
  public login(): void {
    this._msalService.loginRedirect();
  }

  /**
   * Auth logout
   */
  public logout(): void {
    this._contextService.clearContext();
    this._msalService.logout();
  }

  /**
   * Return the raw user from MSAL
   */
  public getAccount(): MsalUser {
    return this._msalService.getAccount();
  }

  /**
   * Get the user's profile
   */
  public getProfile(forceLoad: boolean = false): void {
    if (forceLoad || !this._hasLoaded) {
      this._apiService.get<IUserImport>(
        `${environment.api.globalHost}/2019-03-01/me/profile`
      ).subscribe({
        next: (response: IHttpResponse<IUserImport>) => {
          this.user$.next(new User(response.data));
          this._hasLoaded = true;
        },
        error: (error: IHttpErrorResponse) => {
          let errorRoute = `server-error/${error}`;
          if (error.status === 401 || error.status === 403) {
            errorRoute = "forbidden";
          }
          this._router.navigateByUrl(`/error/${errorRoute}`, {
            skipLocationChange: true,
          });
        }
      });
    }
  }
}
